<template>
  <TfButton
    class="cta-email-support"
    href="mailto:support@threeflow.com"
    size="text"
    tag="a"
    target="_blank"
    :type="type"
    :no-branding="noBranding"
  >
    <slot>
      contact support
    </slot>
  </TfButton>
</template>
<script>
  /**
   * "CtaEmailSupport" is a simple call-to-action component used for opening a user's email client (if set) with the appropriate support email address.
   *
   * @vuedoc
   * @exports TfCtaEmailSupport
   * @category components
   */
  export default {
    name: 'TfCtaEmailSupport',
    props: {
      /**
       * Boolean used to tell the TfButton component to bypass branding styles.
       */
      noBranding: {
        type: Boolean,
        default: false,
      },
      /**
       * String used to tell the TfButton component what button type/color to display.
       */
      type: {
        type: String,
        default: 'primary',
      },
    },
  };
</script>

<style scoped>
  .cta-email-support {
    display: inline-block;
    font-size: inherit;
  }
</style>
